export const ALL_DEMO_DAYS_TAB = 'all';
export const PL_DEMO_DAYS_TAB = 'protocolLabs';
export const PARTNERS_DEMO_DAYS_TAB = 'partners';

export const TABS = [
  {
    label: 'All Demo Days',
    value: ALL_DEMO_DAYS_TAB,
  },
  {
    label: 'PL Demo Days',
    value: PL_DEMO_DAYS_TAB,
  },
  {
    label: 'Partners Demo Days ',
    value: PARTNERS_DEMO_DAYS_TAB,
  },
];

export const CARDS_TO_SHOW_BY_DEFAULT = 3;
